<span #portal><ng-content></ng-content></span>
@if (hasNoAnswer) {
<span class="empty">unanswered</span>
}
